// Disposition des colonnes du CSV d'import prop firm.
//
// Le parseur lit le CSV en positionnel (`header: false`) : ces index sont donc
// la seule source de vérité de l'alignement, et doivent rester synchronisés avec
// `public/edgely-propfirm-template.csv` (verrouillé par importColumns.test.ts).

// Index des colonnes fixes (0-based)
export const COL = {
  propfirm: 0,
  nom_compte: 1,
  tiers: 2,
  taille_compte: 3,
  prix_usd: 4,
  groupe: 5,
  strategie: 6,
  frais_activation: 7,
  date_achat: 8,
  date_cloture: 9,
};

// Les payouts commencent après les colonnes fixes. Décaler cette base suffit à
// insérer de nouvelles colonnes sans toucher au reste du parseur.
export const FIRST_PAYOUT_COL = 10;

export const MAX_PAYOUTS = 20;

export function payoutDateCol(k: number): number {
  return FIRST_PAYOUT_COL + (k - 1) * 2;
}

export function payoutAmountCol(k: number): number {
  return FIRST_PAYOUT_COL + (k - 1) * 2 + 1;
}

/** Le parseur est positionnel : les CSV générés avant l'ajout de
 *  date_achat/date_cloture ont leurs payouts dès la colonne 8. Sans décalage on
 *  lirait une date de payout comme une date d'achat. On détecte l'ancien format
 *  via l'entête et on insère deux colonnes vides. */
export function upgradeLegacyRows(
  headerRow: string[] | undefined,
  dataRows: string[][],
): string[][] {
  const header = (headerRow ?? []).map((h) => h.trim().toLowerCase());
  const isLegacy =
    header.length > 0 &&
    !header.includes("date_achat") &&
    !header.includes("date_cloture");
  if (!isLegacy) return dataRows;

  return dataRows.map((row) => {
    const padded = [...row];
    while (padded.length < COL.date_achat) padded.push("");
    padded.splice(COL.date_achat, 0, "", "");
    return padded;
  });
}
